import React, { useState, useRef, useEffect } from 'react';

function InputBox({ 
  label, 
  reference = useRef(),
  type = "text", 
  name, 
  value, 
  onValueChange, 
  placeholder, 
  required = false, 
  style = {}, 
  className = "", 
  pattern = "",
  onNext,
  icon,
  errorMessage = "",
  onClick, // <- accept onClick prop
  disabled = false
}) {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef();
  const hasValue = value !== undefined && value !== null && value !== '';
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onNext) {
      e.preventDefault();
      onNext();
    }
  };

  // Combined ref for external and internal usage
  useEffect(() => {
    if (reference) {
      reference.current = inputRef.current;
    }
  }, [reference]);

  return (
    <div 
      className={`relative  ${className}`} 
      style={style}
    >
      <div 
        className={`
          relative flex items-center border rounded-xl transition-all duration-300
          ${disabled 
            ? 'bg-gray-100 cursor-not-allowed' 
            : 'bg-white'
          }
          ${errorMessage 
            ? 'border-red-500 shadow-error' 
            : isFocused 
              ? 'border-blue-500 shadow-focus' 
              : 'border-gray-300'
          }
        `}
      >
        {icon && (
          <div className="pl-3 text-gray-400">
            {icon}
          </div>
        )}
        
        <input
          ref={inputRef}
          type={type}
          name={name}
          id={name}
          value={value}
          onChange={onValueChange}
          onKeyDown={handleKeyDown}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onClick={onClick} // <- pass it to input
          placeholder={placeholder}
          required={required}
          pattern={pattern}
          disabled={disabled}
          className={`
            w-full py-2 outline-none bg-transparent transition-all duration-300
            ${icon ? 'pl-3 pr-4' : 'px-4'}
            ${disabled ? 'text-gray-500' : 'text-gray-800'}
            placeholder-gray-400 placeholder-transparent focus:placeholder-gray-400
          `}
        />
        
        {label && (
          <label 
            htmlFor={name}
            className={`
              absolute left-0 transition-all duration-300 pointer-events-none
              ${icon ? 'pl-11 left-0' : 'pl-4'}
              ${isFocused || hasValue
                ? 'top-0 -translate-y-1/2 text-xs px-2 bg-white'
                : 'top-1/2 -translate-y-1/2 text-gray-500'
              }
              ${errorMessage 
                ? 'text-red-500' 
                : isFocused 
                  ? 'text-blue-600' 
                  : 'text-gray-500'
              }
            `}
          >
            {label} {required && <span className="text-red-500">*</span>}
          </label>
        )}
      </div>
      
      {errorMessage && (
        <p className="mt-1 ml-1 text-xs text-red-500 transition-all duration-300">
          {errorMessage}
        </p>
      )}
    </div>
  );
}

export default InputBox;